module.exports = __webpack_public_path__ + "static/media/king-edward-zim-logo.02820cc8.png";